import React, { Component, Fragment } from "react";
import { Image, Button, Row, Col } from "react-bootstrap";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { ITEMTYPEVEG } from "../../../../../enums/OrderEnums";

class SubstituteModal extends Component {
  constructor() {
    super();
    this.state = {
      spice: 4,
      sugar: 4,
      salt: 5,
      fat: 5,
      meat: 5,
      egg: 5,
    };
  }

  redirectToMenu = () => {
    this.props.history.push("/substituteitem");
  };

  getAddOns = (data) => {
    let addOnsNames = [];
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].options.length; j++) {
        addOnsNames.push(data[i].options[j].name);
      }
    }
    return addOnsNames.toString();
  };
  prepareLevels = (data) => {
    let levelNames = [];

    if (data.spice_level) {
      let spice = "Spice : " + data.spice_level.level + "/" + this.state.spice;
      levelNames.push(spice);
    }

    if (data.salt_level) {
      let salt = "Salt : " + data.salt_level.level + "/" + this.state.salt;
      levelNames.push(salt);
    }

    if (data.sugar_level) {
      let sugar = "Sugar : " + data.sugar_level.level + "/" + this.state.sugar;
      levelNames.push(sugar);
    }

    if (data.fat_level) {
      let fat =
        "fat/oil/fried : " + data.fat_level.level + "/" + this.state.fat;
      levelNames.push(fat);
    }

    if (data.meat_cook_level) {
      let meat = "Meat : " + data.meat_cook_level.level + "/" + this.state.meat;
      levelNames.push(meat);
    }

    if (data.egg_cook_level) {
      let egg = "Egg : " + data.egg_cook_level.level + "/" + this.state.egg;
      levelNames.push(egg);
    }
    return levelNames.toString();
  };
  render() {
    return (
      <React.Fragment>
        <div className="superadmin-orderscomponent-main">
          <div className="container-fluid" style={{ marginBottom: "2%" }}>
            <Row>
              <Col md={6}>
                <h5>
                  Order Name:
                  {this.props.allData &&
                    this.props.allData.user_details &&
                    this.props.allData.user_details.first_name}{" "}
                  {this.props.allData &&
                    this.props.allData.user_details &&
                    this.props.allData.user_details.last_name}
                </h5>
              </Col>
              <Col md={6}>
                <h5>
                  Order Type:{" "}
                  <span className="badge badge-warning">Take Away</span>
                </h5>
              </Col>
            </Row>
          </div>

          <div
            className="model-head-view-order-detailed "
            style={{
              border: "1px solid #E0E0E0",
              padding: "1%",
              borderRadius: "5px 0px 0px 5px",
            }}
          >
            <div
              style={{
                borderRadius: "5px",
                borderLeft: "5px solid #37ac1e",
                paddingLeft: "1%",
              }}
            >
              <table className="model-view-order-detailed-table">
                <thead>
                  <th style={{ width: "8%" }}>Order Type</th>
                  <th style={{ width: "18%" }}>Name & Request No.</th>
                  <th style={{ width: "10%" }}>No. Items</th>
                  <th style={{ width: "10%" }}>Amount / Payment</th>
                  <th style={{ width: "20%" }}>Order Reference</th>
                  <th style={{ width: "25%" }}>Date / Time / Timer</th>
                </thead>
                <tbody style={{ marginTop: "1%" }}>
                  <tr>
                    <td>
                      <img
                        src={require("../../../../../assets/images/superadmin/ordericon/takeaway.svg")}
                        width="35px"
                      />
                    </td>
                    <td>
                      {this.props.allData &&
                        this.props.allData.user_details &&
                        this.props.allData.user_details.first_name}{" "}
                      {this.props.allData &&
                        this.props.allData.user_details &&
                        this.props.allData.user_details.last_name}
                      <br />
                      <span style={{ fontSize: ".75rem" }}>
                        #{" "}
                        {this.props.allData &&
                          this.props.allData.user_details &&
                          this.props.allData.user_details.country_code}{" "}
                        {this.props.allData &&
                          this.props.allData.user_details &&
                          this.props.allData.user_details.mobile_number}
                      </span>
                    </td>

                    <td>
                      {" "}
                      {this.props.allData &&
                        this.props.allData &&
                        this.props.allData.order_items.length}
                    </td>
                    <td>
                      ₹{" "}
                      {this.props.allData &&
                        this.props.allData &&
                        this.props.allData.total_amount}{" "}
                      <br />
                      <span className="badge badge-success">PAID</span>
                      <br />
                      {this.props.allData &&
                      this.props.allData.payment_method === 0
                        ? "COD"
                        : this.props.allData.payment_method === 1
                        ? "UPI"
                        : this.props.allData.payment_method === 2
                        ? "Paytm"
                        : this.props.allData.payment_method === 3
                        ? "Debit Card"
                        : this.props.allData.payment_method === 4
                        ? "Credit Card"
                        : this.props.allData.payment_method === 5
                        ? "NetBanking"
                        : this.props.allData.payment_method === 6
                        ? "Pay Later"
                        : this.props.allData.payment_method === 7
                        ? "Wallet"
                        : this.props.allData.payment_method === 8
                        ? "External Wallet"
                        : this.props.allData.payment_method === 9
                        ? "Cash"
                        : null}
                    </td>
                    <td>
                      {this.props.allData.order_type === 1 ? (
                        <Fragment>
                          {this.props.allData &&
                            this.props.allData.curb_side_details &&
                            this.props.allData.curb_side_details
                              .vehical_number}{" "}
                          <br />
                          {this.props.allData &&
                            this.props.allData.curb_side_details &&
                            this.props.allData.curb_side_details.model}{" "}
                          {this.props.allData &&
                            this.props.allData.curb_side_details &&
                            this.props.allData.curb_side_details.make}
                          |{" "}
                          {this.props.allData &&
                            this.props.allData.curb_side_details &&
                            this.props.allData.curb_side_details.color}
                        </Fragment>
                      ) : (
                        <Fragment>N/A</Fragment>
                      )}
                    </td>
                    <td>
                      <p
                        style={{
                          color: "#EE3A23",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <span style={{ fontSize: "1.25rem" }}>12:15:22</span>
                        &nbsp;&nbsp;
                        <Button
                          variant="link"
                          className="enIconBtn mr-3 action_icon_padding"
                          // onClick={props.ratingReviewAction}
                        >
                          <Image
                            src={require("../../../../../assets/images/superadmin/ordericon/Edit.svg")}
                            alt="Rating"
                            title="Rating"
                            fluid
                          />
                        </Button>{" "}
                      </p>

                      <span>29th August 2019 12:15 PM</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr />
            <br />
            <Row>
              <Col md={4}>
                <h5>Order Placed Date & Time</h5>
                <br />
                <p>
                  {moment(
                    this.props.allData && this.props.allData.createdAt
                  ).format("Do MMMM YYYY")}
                  |
                  {moment(
                    this.props.allData && this.props.allData.createdAt
                  ).format("hh : mm A")}
                </p>
              </Col>

              <Col md={2}>
                <h5>User Location</h5>
                <br />
                <center>
                  <img
                    src={require("../../../../../assets/images/superadmin/ordericon/location_red.svg")}
                    width="25px"
                  />
                </center>
              </Col>
              <Col md={6}>
                <div
                  className="container-fluid main-orders-table-action"
                  align="center"
                >
                  <p style={{ fontSize: ".75rem" }}>Total wait time</p>
                  <div className="row">
                    <div className="col-3">
                      <button className="btn add_button_custom_1 ">
                        Cancel
                      </button>
                    </div>
                    <div
                      className="col-5"
                      style={
                        {
                          // background: "#F0F0F0 0% 0% no-repeat padding-box",
                          // borderRadius: "6px",
                        }
                      }
                    >
                      <button
                        className="btn btn-secondary w-100"
                        style={{
                          fontSize: ".75rem",
                          background: "#F0F0F0 0% 0% no-repeat padding-box",
                          borderRadius: "6px",
                          color: "#000000",
                        }}
                      >
                        <img
                          src={require("../../../../../assets/images/superadmin/ordericon/hourglass.svg")}
                          width="15px"
                        />
                        00 hh : 20 mins
                      </button>
                    </div>
                    <div className="col-4">
                      <button className="btn add_button_custom_success">
                        Getting Prep
                      </button>
                    </div>
                  </div>
                  <div>Status: Accepted</div>
                </div>
              </Col>
            </Row>
            <hr />
            <br />
            <Row>
              <Col md={3} style={{ borderRight: "1px solid #E0E0E0" }}>
                <div className="more-actions-orders-desc d-flex justify-content-end mb-2">
                  <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                    // onClick={props.ratingReviewAction}
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/call.svg")}
                      alt="Call"
                      title="Call"
                      fluid
                    />
                  </Button>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                    // onClick={props.ratingReviewAction}
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/Edit.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </Button>{" "}
                  <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                    // onClick={props.ratingReviewAction}
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/Notifications.svg")}
                      alt="Notify"
                      title="Notify"
                      fluid
                    />
                  </Button>
                </div>
              </Col>
              <Col md={5} style={{ borderRight: "1px solid #E0E0E0" }}>
                <h5>Order Notes</h5>
                <br />
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.Fusce.
                </p>
              </Col>
              <Col md={4}>
                <button className="btn bordered-button-primary">
                  Cancel Order
                </button>
              </Col>
            </Row>
            <hr />
            <br />
            <div className="table-responsive">
              <table className="table desc-order-info">
                <thead>
                  <tr
                    style={{
                      backgroundColor: "transparent",
                      borderTop: "hidden",
                    }}
                  >
                    {/* <th style={{ width: "3%" }}></th> */}
                    <th style={{ width: "13%" }} colSpan={2}>
                      Order Items
                    </th>
                    <th style={{ width: "3%" }}>Qty</th>
                    <th style={{ width: "20%" }}>Customization</th>
                    <th style={{ width: "20%" }}>
                      Personalization/ Item Notes
                    </th>
                    <th style={{ width: "10%" }}>Amount</th>
                    <th style={{ width: "10%" }}>ETC</th>
                    {/* <th style={{ width: "8%" }}>
                      Counter <br />
                      No.
                    </th> */}
                    {/* <th style={{ width: "10%" }}>Item Status</th> */}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: "5%" }}>
                      {ITEMTYPEVEG.map((type, index) => {
                        return (
                          <React.Fragment key={index}>
                            {this.props.itemData.item?.itemType ===
                            type?.value ? (
                              <Image
                                width="20px"
                                src={type.url}
                                alt={type.title}
                                title={type.title}
                                fluid
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      })}
                    </td>
                    <td style={{ width: "10%" }}>
                      {this.props.itemData.item.name}
                    </td>
                    <td style={{ width: "3%" }}>
                      {" "}
                      {this.props.itemData.quantity}
                    </td>
                    <td style={{ width: "20%" }}>
                      {" "}
                      {this.props.itemData.addOns.length > 0 ? (
                        this.getAddOns(this.props.itemData.addOns)
                      ) : (
                        <Fragment>N/A</Fragment>
                      )}
                    </td>
                    <td style={{ width: "20%" }}>
                      {this.props.itemData.customised_details
                        ? this.prepareLevels(
                            this.props.itemData.customised_details
                          )
                        : " "}{" "}
                      {this.props.itemData.notes}
                    </td>
                    <td style={{ width: "10%" }}>
                      ₹ {this.props.itemData.size.price}
                    </td>
                    <td style={{ width: "10%" }}>
                      {this.props.itemData.item.prepTime}
                    </td>
                    {/* <td style={{ width: "8%" }}>A1</td> */}
                    {/* <td style={{ width: "10%" }}>
                      <button className="btn btn-secondary">
                        Substitute/
                        <br />
                        Cancel
                      </button>
                    </td> */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <br />
          <br />

          <button
            style={{
              width: "273px",
              height: "50px",
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              border: "1px solid #EE3A23",
              boxShadow: "0px 3px 6px #6E6E6E21",
              borderRadius: "5px",
            }}
            onClick={() => this.redirectToMenu()}
          >
            Select items from the menu
          </button>
          <br />
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(SubstituteModal);
